import { defineComponent } from "vue";
export default defineComponent({
  name: "ImgIcon",
  props: ["file", "alt"],
  methods: {
    imgSrc: function imgSrc() {
      return require("@/assets/img/icons/" + this.file);
    },
    imgAlt: function imgAlt() {
      return this.alt || "";
    }
  }
});